import { state } from './state.js';
import { mutations } from './mutations.js';
import { actions } from './actions.js';
import { getters } from './getters.js';
import * as MUTATIONS from '@/store/constants/mutations.js';
import * as GETTERS from '@/store/constants/getters.js';
import * as ACTIONS from '@/store/constants/actions.js';
import { INACTIVITY_THRESHOLD, TIME_TRACKING_EVENTS } from '@/constants/time.js';

const TIME_INCREMENT = 1000;

export const time = () => ({
    state: state(),
    mutations,
    getters,
    actions,
});

/**
 *
 * run once on store initialization to periodically update the time in the store
 *
 * @param {Object} store vuex store
 */
export const timePlugin = ({ commit, getters, dispatch }) => {
    setInterval(() => {
        const currentTime = getters[GETTERS.CURRENT_TIME];

        dispatch(ACTIONS.INCREMENT_ATTENTION_TIME, TIME_INCREMENT);

        commit(MUTATIONS.UPDATE_PREVIOUS_TIME);
        commit(MUTATIONS.UPDATE_CURRENT_TIME);

        const lastActive = getters[GETTERS.LAST_ACTIVE];
        const idleTime = currentTime - lastActive;
        const isInactive = getters[GETTERS.IS_INACTIVE];

        if (isInactive) {
            return;
        }

        // Set inactivity if the idletime exceeds the threshold. If inactive, don't accrue any more attention time
        commit(MUTATIONS.SET_INACTIVE, idleTime > INACTIVITY_THRESHOLD);
        if (idleTime > INACTIVITY_THRESHOLD) {
            commit(MUTATIONS.ADD_EVENT_TO_HISTORY, TIME_TRACKING_EVENTS.idle());
        }
    }, TIME_INCREMENT);
};
